export const changeDistrictNameReducer = (state = "AlFaw", action) => {
    switch (action.type) {
      case "CHANGE_DISTRICT_NAME":
        return action.payload.districtName;
      default:
        return state;
    }
  };
  